import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"
import "./analyzer.css";
import Upload from "../components/fileupload";
import TextInput from "../components/inputTextBox";
import Loader from "../components/loader";
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth } from "@clerk/clerk-react";
import toast, { Toaster } from "react-hot-toast";
export default function Analyzer(){
    // jobsniper-be-production.up.railway.app  (URI OF EXPRESS BACKEND)
    //  analyze button click -> razorpay --success ? loading screen -> dashboard : else analyzer
    const [resumeFile, setResumeFile] = useState(null);
    const [JDtext, setJD] = useState("");
    const [showOverlay, setOverlay] = useState(false);
    const [showLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { getToken } = useAuth();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "http://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);


    const createOrder = async () => {
        try {
            const res = await fetch("https://jobsniper-be-production.up.railway.app/api/create_order", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ amount: 149 })  // example price
            });

            const order = await res.json();

            return order; // contains order.id, amount, currency
        } catch (err) {
            console.error("Order creation failed", err);
        }
    };

    const handlePayment = async () => {
        const t = toast.loading("Processing your payment...", {position:"bottom-right"});
        const order = await createOrder();  // from step 2
        const token = await getToken();
        const res = await fetch("https://jobsniper-be-production.up.railway.app/userinfo", {
            method: "POST",
            headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            },
        });
        const data = await res.json();
        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY_ID, 
            amount: order.amount,
            currency: order.currency,
            name: "JobSniper",
            description: "Standard Flow Analysis Payment",
            order_id: order.id,

            handler: async function (response) {
                const verify = await fetch("https://jobsniper-be-production.up.railway.app/api/verify_payment", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                        user_id: data.user_id // pass this from frontend
                    })
                });
                
                const verification_res = await verify.json();
                
                if (verification_res.status === "success") {
                    toast.success("Payment Succcessful! Starting the analysis", {id: t, position:"bottom-right"})
                    const formData = new FormData();
                    formData.append("resume", resumeFile);
                    formData.append("jd_text", JDtext);
                    setOverlay(false);
                    setLoading(true);
                    try {
                        const token = await getToken();
                        const response = await fetch("https://jobsniper-be-production.up.railway.app/jsep", {
                            method: "POST",
                            headers: {"Authorization": `Bearer ${token}`},
                            body: formData,
                        });
                        
                        if (!response.ok) throw new Error("Failed to analyze. Please try again.");
                        const data = await response.json();
                        
                        const skillGapData = data.skill_gap;
                        const roadmapData = data.roadmap;
                        const flow_name = data.flow_name;
                        setLoading(false);
                        const source = "analyzer";
                        const flow_id = null;
                        navigate("/dashboard", { state: {flow_id, skillGapData, roadmapData, flow_name, source} });
                    } catch (error) {
                        console.error("Error:", error);
                        alert("Our backend is under load. Your roadmap is still being processed. If the issue persists, please email jobsniperteam@gmail.com for manual generation of the roadmap.");
                    }
                } else {
                    // BAD
                    toast.error("Payment cancelled or failed", { id: t, position: "bottom-right" });
                }
                return;
            },

            modal:{
                ondismiss: () => {
                    toast.error("Payment cancelled or failed", { id: t, position: "bottom-right" });
                }
            },
            prefill: {
                email: data.email_address,
            },
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
    };

    // endpoint: http://jobsniper-be-production.up.railway.app/check_free_roadmap_count
    const handleAnalyze = async () => {
      if (!resumeFile || !JDtext) {
        alert("Please upload your Resume and paste the Job Description.");
        return;
      }
      const t = toast.loading("Checking for free roadmaps...", {position: "bottom-right"})
      const token = await getToken();
      const res = await fetch("https://jobsniper-be-production.up.railway.app/check_free_roadmap_count",
        {
            method: "GET",
            headers:{
                "Authorization": `Bearer ${token}`
            }
        }
    );
    const data = await res.json();
    // endpoint: http://jobsniper-be-production.up.railway.app/jsep
    if(data.isFreeRoadmapAvail){
        toast.success("You have a free roadmap! Starting the analysis", {id: t, position:"bottom-right"})
        const formData = new FormData();
        formData.append("resume", resumeFile);
        formData.append("jd_text", JDtext);
        setOverlay(false);
        setLoading(true);
        try {
            const token = await getToken();
            const response = await fetch("https://jobsniper-be-production.up.railway.app/jsep", {
                method: "POST",
                headers: {"Authorization": `Bearer ${token}`},
                body: formData,
            });
            
            if (!response.ok) throw new Error("Failed to analyze. Please try again.");
            const data = await response.json();
            
            const skillGapData = data.skill_gap;
            const roadmapData = data.roadmap;
            const flow_name = data.flow_name;
            setLoading(false);
            const source = "analyzer";
            const flow_id = null;
            navigate("/dashboard", { state: {flow_id, skillGapData, roadmapData, flow_name, source} });
        } catch (error) {
            console.error("Error:", error);
            alert("Our backend is under load. Your roadmap is still being processed. If the issue persists, please email jobsniperteam@gmail.com for manual generation of the roadmap.");
        }
      }
      else{
        toast.error("You dont have a free roadmap left", {position:"bottom-right", id:t});
        setOverlay(true);
      }

    };

    return (    
        <div>
            <Toaster />
            { 
            !showLoading?
            
            <div className="analyzer_parent">
                {
                    !showOverlay?
                    <div className="analyzer_container">
                        <div className="analyzer_header">
                            <div className="analyzer_hero">
                                See Exactly <b>Where You Stand</b>.
                            </div>
                            <div className="analyzer_subtext">
                                Upload your resume and the target Job Description to get a precise skill gap analysis and a clear path forward.
                            </div>
                        </div>
                        <div className="inputs">
                            <div className="inputs_sub">  
                                <div className="inputs_widget">
                                    <div>Resume/CV</div>
                                    <Upload onFileSelect={(f)=>{setResumeFile(f)}} placeholderText={"Upload Your Resume (pdf)"} />
                                </div>
                                <div className="inputs_widget">
                                    <div>Job Description</div>
                                    <TextInput value={JDtext} onChange={(e)=>{setJD(e.target.value)}} placeholderText={"Paste the Job Description for the role you’re applying to"} />
                                </div>
                            </div>
                        </div>
                        <div className="analyzer_footer">
                            <div className="hero_gradient_cta" onClick={handleAnalyze}>
                                Analyze me!
                            </div>
                        </div>
                    </div>
                    :
                    <div className="payment_overlay">
                        <div className="payment_header_parent">
                            <div className="payment_header">Pick your analysis</div>
                            <ClearIcon onClick={()=>{setOverlay(false)}} />
                        </div>
                        <div className="payment_overlay_container">
                            <div className="plan_widget">
                                <div className="plan_widget_name">Starter <span className="recommendation_clause">*recommended for first time users</span></div>
                                <div className="plan_widget_benefits">
                                    <div>Benefits</div>
                                    <ul>
                                        <li>✔️ Auto-generated Flow based on your resume</li>
                                        <li>✔️ Saved Flows dashboard</li>
                                        <li>✔️ Role-specific Flow creation</li>
                                        <li>✔️ Email nudges to keep you consistent</li>
                                        <li>✔️ Priority email support</li>
                                    </ul>
                                </div>
                                <div className="plan_widget_pay_now_button" onClick={()=>{handlePayment()}}>Start Analysis – Rs.149</div>
                            </div>
                            <div className="plan_widget_coming_soon">
                                <div className="plan_widget_name">Edge</div>
                                <div className="plan_widget_price">Coming Soon...</div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            :
            <div className="loadParent">
                <Loader className="load" />
            </div>
            }
        </div>
    )
}
